import styled from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'
import { theme } from '../../../../../../style/theme'

export const InvoiceSheetWrap = styled.div`
	position: relative;
	overflow: hidden;
	padding: 6.25em 5em 3.13em;
	border: 1px dashed ${colorTheme.invoices.modal.invoiceData.border};
	border-radius: 0.75em;
	background: ${colorTheme.invoices.modal.invoiceData.background};
	font-size: 1rem;
`
InvoiceSheetWrap.displayName = 'InvoiceSheetWrap'

export const InvoiceLabelBill = styled.div`
	position: absolute;
	top: 2.45em;
	right: -3.66em;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.44em;
	width: 15.63em;
	height: 3.5em;
	transform: rotate(45deg);

	> svg {
		flex-shrink: 0;
		width: 1.75em;
		height: 1.75em;
		fill: ${colorTheme.invoices.modal.invoiceData.label.icon};
	}

	&.green {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundGreen};
	}

	&.orange {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundOrange};
	}

	&.canceled {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundCanceled};
	}
`
InvoiceLabelBill.displayName = 'InvoiceLabelBill'

export const InvoiceCompactWrap = styled.div`
	@media screen and (max-width: ${theme.point820}) {
		margin-bottom: 6em;
	}
`
InvoiceCompactWrap.displayName = 'InvoiceCompactWrap'

export const InvoiceStatusBar = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.44em;
	margin-bottom: 1.25em;
	padding: 0.88em 0;

	> svg {
		flex-shrink: 0;
		width: 1.75em;
		height: 1.75em;
		fill: ${colorTheme.invoices.modal.invoiceData.label.icon};
	}

	&.green {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundGreen};
	}

	&.orange {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundOrange};
	}

	&.canceled {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundCanceled};
	}

	@media screen and (max-width: ${theme.point820}) {
		margin: -0.63em -0.63em 1.25em;
	}
`
InvoiceStatusBar.displayName = 'InvoiceStatusBar'

export const InvoiceLabelText = styled.div`
	color: ${colorTheme.invoices.modal.invoiceData.label.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.25em;
	font-weight: 600;
`
InvoiceLabelText.displayName = 'InvoiceLabelText'
